(function () {
  function initSection(section) {
    if (!section) return;

    section.querySelectorAll('.ciw-pdp-rec__title').forEach(function (el) {
      el.style.fontSize = '';
      el.classList.add('ciw-pdp-rec__title--clamped');
    });
  }

  function init() {
    var sections = document.querySelectorAll('[data-ciw-pdp-rec]');
    if (!sections.length) return;

    sections.forEach(initSection);

    document.addEventListener('ciw:cart-rec-updated', function (event) {
      var section = event && event.detail && event.detail.section;
      if (section) {
        initSection(section);
        return;
      }
      sections.forEach(initSection);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
